const currencyDto = {
  id: 0,
  description: null,
  idUserCreated: 0,
  userCreated: null,
  dateCreated: null,
  idUserUpdated: 0,
  userUpdated: null,
  dateUpdated: null,
  descrip: null,
};

const typeDocumentDto = {
  id: 0,
  typeDocument: null,
  idUserCreated: 0,
  userCreated: null,
  dateCreated: null,
  idUserUpdated: 0,
  userUpdated: null,
  dateUpdated: null,
  descrip: null,
};

const regionDto = {
  id: 0,
  name: null,
  idUserCreated: 0,
  userCreated: null,
  dateCreated: null,
  idUserUpdated: 0,
  userUpdated: null,
  dateUpdated: null,
  descrip: null,
};

const currencyDenominationDto = {
  id: 0,
  idCurrency: 0,
  currency: null,
  value: 0,
  img: null,
  imgList: null,
  idUserCreated: 0,
  userCreated: null,
  dateCreated: null,
  idUserUpdated: 0,
  userUpdated: null,
  dateUpdated: null,
  descrip: null,
};

export default {
  currencyDto,
  regionDto,
  typeDocumentDto,
  currencyDenominationDto,
};
